import { SearchState } from '../../../models';
import { SEARCH_MUTATIONS_KEYS } from '../search.const';
import { SearchMutation } from '../search.interfaces';

export class SetLoadingMutation implements SearchMutation {

  mutations = {
    [SEARCH_MUTATIONS_KEYS.setLoading]: (searchState: SearchState, loading: boolean) => {
      searchState.loading = loading;
    }
  };
}
